import React from "react";
import { Wind, CloudLightning, Sparkles, ShieldAlert, HelpCircle } from "lucide-react";
import { Panel, Kicker } from "../ciWidgets";

const CLASS_META = {
  tailwind: [Wind, "text-emerald-300 border-emerald-400/30 bg-emerald-400/[0.06]", "Tailwind"],
  headwind: [CloudLightning, "text-red-300 border-red-400/30 bg-red-400/[0.06]", "Headwind"],
  emerging_opportunity: [Sparkles, "text-teal-300 border-teal-400/30 bg-teal-400/[0.06]", "Emerging opportunity"],
  strategic_threat: [ShieldAlert, "text-amber-300 border-amber-400/30 bg-amber-400/[0.06]", "Strategic threat"],
  uncertain: [HelpCircle, "text-slate-300 border-slate-400/30 bg-slate-400/[0.06]", "Uncertain / scenario-dependent"],
};

export const TrendsTab = ({ report }) => {
  const trends = report.industry_trends || [];
  return (
    <div className="space-y-6" data-testid="ci-tab-trends">
      <Panel className="p-7">
        <Kicker className="mb-2">Industry trends &amp; scenarios</Kicker>
        <p className="text-[13px] text-white/50 mb-6">
          Each trend is classified with impact, probability and horizon — plus the recommended company response.
        </p>
        <div className="grid md:grid-cols-2 gap-4">
          {trends.map((t, i) => {
            const [Icon, cls, label] = CLASS_META[t.classification] || CLASS_META.uncertain;
            return (
              <div key={i} className="rounded-xl border border-white/10 bg-[#060d18] p-5" data-testid={`ci-trend-card-${i}`}>
                <div className="flex items-center justify-between gap-3 mb-3">
                  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold tracking-[0.1em] uppercase ${cls}`}>
                    <Icon className="w-3 h-3" /> {label}
                  </span>
                  <span className="text-[11px] text-white/40">{t.horizon}</span>
                </div>
                <div className="text-[14px] font-semibold text-white mb-2 leading-snug">{t.trend}</div>
                <div className="flex gap-4 text-[11px] text-white/50 mb-3">
                  <span>Impact: <b className="text-white/75">{t.impact}</b></span>
                  <span>Probability: <b className="text-white/75">{t.probability}</b></span>
                </div>
                {t.evidence && <div className="text-[12px] text-white/50 leading-relaxed mb-3">{t.evidence}</div>}
                <div className="text-[12px] text-teal-200 leading-relaxed border-t border-white/8 pt-3">
                  <b>Response:</b> {t.response}
                </div>
              </div>
            );
          })}
        </div>
      </Panel>
    </div>
  );
};
